import types from '../types'
import {getModelMetaData} from './getModelMetaData'

export const onSignInSuccess =
  (orgId, authKey) => async (dispatch) => {
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {isLoading: true},
    })
    const modelMetaData = await dispatch(getModelMetaData(orgId, authKey))
    const hasData = modelMetaData && Object.keys(modelMetaData).length > 0
    if (hasData) {
      localStorage.setItem('lzr_orgId', orgId)
      localStorage.setItem('lzr_authKey', authKey)
      localStorage.setItem('lzr_auth_expiry', Date.now() + 30 * 60 * 1000)
      dispatch({
        type: types.STORE_PAYLOAD,
        payload: {
          orgId,
          authKey,
          isSignedIn: true,
          isLoading: false,
        },
      })
    } else {
      dispatch({
        type: types.STORE_PAYLOAD,
        payload: {
          isLoading: false,
          isSignedIn: false,
          userMessage: 'You do not appear to have a Lazarus Account. Reach out to your Lazarus Representative or reach out to us through lazarusai.com.',
          notificationIcon: 'warning',
          notificationType: 3,
        },
      })
    }
  }
